import VoucherListView from "../../components/VoucherListView";

VoucherListScreen.propTypes = {};

function VoucherListScreen(props) {
    // MARK: ---- PROPERTIES ----

    return (
        <div>
            <div className="container-fluid px-4 my-4">
                <VoucherListView />
            </div>
        </div>
    );
}

export default VoucherListScreen;
